<template>
  <div>
    <template v-if="userType === 'kunde'">
      <v-select
        dense
        outlined
        label="Anschreiben"
        :items="adressAuswahl"
        v-model="selectedAdresstyp"
      ></v-select>
      <v-select
        v-if="hasMoreThanOneBauvorhaben"
        dense
        outlined
        label="Bauvorhaben auswählen"
        :items="user.bauvorhaben"
        item-text="bv_nr"
        item-value="id"
        return-object
        v-model="selectedBauvorhaben"
      ></v-select>
      <v-sheet outlined rounded class="pa-5 mb-5" style="white-space: pre-line">
        <p class="text-h6">Versandadresse:</p>
        <p v-if="selectedAdresstyp === 'Heimadresse'">
          {{ formatAddress(user) }}
        </p>
        <p v-else-if="user.bauvorhaben.length === 1">
          {{ formatAddress(user, false) }}<br />
          <template v-if="hasBauvorhabenAdresse">
            {{ formatBaseAddress(user.bauvorhaben[0]) }}
          </template>
          <template v-else>
            <v-icon color="error" class="mr-2">{{ icons.mdiClose }}</v-icon
            >Keine Adresse für das Bauvorhaben hinterlegt!
          </template>
        </p>
        <p v-else-if="hasMoreThanOneBauvorhaben">
          {{ formatAddress(user, false) }}<br />
          {{ formatBaseAddress(selectedBauvorhaben) }}
        </p>
      </v-sheet>
    </template>
    <v-sheet
      v-else-if="userType === 'dienstleister'"
      outlined
      rounded
      class="pa-5 mb-5"
    >
      <p class="text-h6">Versandadresse:</p>
      <p v-if="userType === 'dienstleister'" class="text-pre-line">
        {{ user.name }}<br />
        {{ formatBaseAddress(user) }}
      </p>
      <p v-else class="text-pre-line">
        {{ formatAddress(user) }}
      </p>
    </v-sheet>
    <v-text-field
      outlined
      dense
      label="Betreff"
      v-model="subject"
    ></v-text-field>
    <v-select
      dense
      outlined
      label="Ansprache"
      :items="ansprachen"
      v-model="ansprache"
    ></v-select>
    <p v-if="ansprache === 'sie'" class="text--disabled">
      <template v-if="userType === 'dienstleister'">
        Sehr geehrte Damen und Herren,
      </template>
      <template v-else> {{ generateSalutationLine(user) }}, </template>
    </p>
    <v-text-field
      v-else
      dense
      outlined
      label="Persönliche Ansprache"
      v-model="anspracheText"
    ></v-text-field>
    <div class="mb-4">
      <ckeditor
        :editor="editor"
        :config="editorConfig"
        v-model="message"
      ></ckeditor>
    </div>
    <v-text-field
      dense
      outlined
      hide-details
      label="Gruß"
      placeholder="Mit freundlichen Grüßen"
      v-model="grussText"
    ></v-text-field>
    <p class="text--disabled mt-2">
      {{ authUser.vorname }} {{ authUser.nachname }}
    </p>
    <p class="text--disabled mb-0">Telefon: {{ authUser.telefonnr }}</p>
    <p v-if="authUser.mobilnr" class="text--disabled mb-0">
      Mobil: {{ authUser.mobilnr }}
    </p>
    <p class="text--disabled mb-6">E-Mail: {{ authUser.email }}</p>
    <v-textarea
      auto-grow
      dense
      outlined
      label="Zusatztext"
      v-model="additionalText"
      rows="3"
    ></v-textarea>
  </div>
</template>

<script>
import Editor from "ckeditor5-custom-build/build/ckeditor";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import AddressFormatter from "@/mixins/AddressFormatter";
import { mdiClose } from "@mdi/js";

export default {
  name: "FormNewBrief",
  components: {
    ckeditor: CKEditor.component,
  },
  props: {
    user: {
      type: Object,
      default: () => {},
      required: true,
    },
    userType: {
      type: String,
      default: "interessent",
    },
    initialSubject: {
      type: String,
      default: "",
    },
    initialAnsprache: {
      type: String,
      default: "sie",
    },
    initialAnspracheText: {
      type: String,
      default: "",
    },
    initialMessage: {
      type: String,
      default: "",
    },
    initialGrussText: {
      type: String,
      default: "Mit freundlichen Grüßen",
    },
    initialAdditionalText: {
      type: String,
      default: "",
    },
  },
  mixins: [AddressFormatter],
  data() {
    return {
      editor: Editor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "|",
          "bulletedList",
          "numberedList",
          "|",
          "undo",
          "redo",
        ],
      },
      adressAuswahl: ["Heimadresse", "Baustellenadresse"],
      selectedAdresstyp: "Heimadresse",
      bauvorhabenItems: [],
      selectedBauvorhaben: {},
      subject: this.initialSubject,
      ansprachen: [
        { text: "Persönlich (Du)", value: "du" },
        { text: "Förmlich (Sie)", value: "sie" },
      ],
      ansprache: this.initialAnsprache,
      anspracheText: this.initialAnspracheText,
      message: this.initialMessage,
      grussText: this.initialGrussText,
      additionalText: this.initialAdditionalText,
      rules: {
        required: (value) => !!value || "Dies ist ein Pflichtfeld.",
      },
      icons: {
        mdiClose,
      },
    };
  },
  computed: {
    authUser() {
      return this.$store.state.user.authUser;
    },
    anrede() {
      let anrede = "";

      if (this.$props.user.anrede && this.$props.user.anrede.includes("Herr")) {
        anrede = "Sehr geehrter ";
      } else {
        anrede = "Sehr geehrte ";
      }

      return anrede;
    },
    anrede2() {
      let anrede = "";

      if (
        this.$props.user.anrede_2 &&
        this.$props.user.anrede_2.includes("Herr")
      ) {
        anrede = "sehr geehrter ";
      } else {
        anrede = "sehr geehrte ";
      }

      return anrede;
    },
    hasMoreThanOneBauvorhaben() {
      return this.$props.user.bauvorhaben.length > 1;
    },
    hasBauvorhabenAdresse() {
      return (
        (this.$props.user.bauvorhaben[0].strasse ||
          this.$props.user.bauvorhaben[0].hausnr) &&
        this.$props.user.bauvorhaben[0].plz &&
        this.$props.user.bauvorhaben[0].ort
      );
    },
    formData() {
      return {
        adressTyp: this.selectedAdresstyp,
        subject: this.subject,
        ansprache: this.ansprache,
        anspracheText: this.anspracheText,
        message: this.message,
        grussText: this.grussText,
        additionalText: this.additionalText,
        selectedBauvorhaben: this.selectedBauvorhaben,
        bauvorhabenId: this.selectedBauvorhaben?.id ?? null,
      };
    },
  },
  watch: {
    formData: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true,
      immediate: true,
    },
    initialSubject(newVal) {
      this.subject = newVal;
    },
    initialAnsprache(newVal) {
      this.ansprache = newVal;
    },
    initialAnspracheText(newVal) {
      this.anspracheText = newVal;
    },
    initialMessage(newVal) {
      this.message = newVal;
    },
    initialGrussText(newVal) {
      this.grussText = newVal;
    },
    initialAdditionalText(newVal) {
      this.additionalText = newVal;
    },
  },
};
</script>

<style scoped></style>
